import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Users, Trophy, User, Bell, Sparkles } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/lib/auth";

const NAV = [
  { to: "/", label: "Ana Sayfa", icon: Home, testId: "side-home" },
  { to: "/masalar", label: "Masalar", icon: LayoutGrid, testId: "side-tables" },
  { to: "/arkadaslar", label: "Arkadaşlar", icon: Users, testId: "side-friends" },
  { to: "/siralama", label: "Sıralama", icon: Trophy, testId: "side-leaderboard" },
  { to: "/bildirimler", label: "Bildirimler", icon: Bell, testId: "side-notifications" },
  { to: "/profil", label: "Profil", icon: User, testId: "side-profile" },
];

/**
 * lg+ (>=1024px) ekranlarda görünen kalıcı yan menü. Aynı zamanda geniş ekranı
 * daha akıllı kullanmak için sol tarafta oturan bir "iki sütunlu" düzen sağlar.
 */
export default function DesktopSidebar() {
  const { user } = useAuth();
  return (
    <aside
      data-testid="desktop-sidebar"
      className="hidden lg:flex fixed left-0 top-0 bottom-0 w-64 xl:w-72 z-30 border-r border-border bg-card/70 backdrop-blur-md flex-col"
    >
      <div className="px-6 py-6 flex items-center gap-2">
        <Logo size={40} />
        <div>
          <p className="font-display font-extrabold text-lg leading-none">Okeydaş</p>
          <p className="text-[10px] uppercase tracking-widest text-muted-foreground mt-1">Arkadaşlarla Okey</p>
        </div>
      </div>

      <nav className="px-3 flex-1 space-y-1">
        {NAV.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-semibold transition-all ${
                isActive
                  ? "bg-primary/10 text-primary shadow-sm"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={`h-8 w-8 rounded-xl flex items-center justify-center transition-colors ${
                    isActive ? "bg-primary text-primary-foreground" : "bg-secondary text-foreground/70"
                  }`}
                >
                  <Icon className="h-4 w-4" />
                </span>
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {user?.role === "admin" && (
        <div className="px-3 pb-3">
          <NavLink
            to="/yonetim"
            data-testid="side-admin"
            className={({ isActive }) =>
              `flex items-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold transition-colors ${
                isActive ? "bg-accent/20 text-accent-foreground" : "text-muted-foreground hover:text-foreground"
              }`
            }
          >
            <Sparkles className="h-3.5 w-3.5" /> Yönetim Paneli
          </NavLink>
        </div>
      )}

      <div className="px-6 pb-5 pt-2 text-[10px] text-muted-foreground">
        © 2026 Okeydaş · Bahis/kumar içermez
      </div>
    </aside>
  );
}
